import './style.scss';
import { Grid } from "@mui/material";
import Content from './Content';
import Footer from './Footer';
import { HashRouter } from 'react-router-dom';
import Copyright from './Copyright';
import ChangeLanguage from './ChangeLanguage';


const Website = () => {
    return <>
        <Grid container className='container-website'>
            <HashRouter basename='/'>
                <Content />
                <Footer />
                <Copyright />
            </HashRouter>
        </Grid>

        <ChangeLanguage />
    </>;
}

export default Website;